<template>
    <div class="px-2">      
        <p class="mt-2 mb-0"> <b>periodo de seleccion:</b> <span v-html="periodo_dis"></span> </p>
        <h5 class="text-center green darken-3 py-2 mb-1 mt-0">
            <b class="white--text"> Clasificacion de lista de proyectos para {{ $store.state.CARGO.sede.nombre }} </b>
        </h5>
        <h5 class="text-center blue darken-4 mt-0 mx-8">
            <b class="white--text"> autoria </b>
        </h5>
 
        <v-data-table
            :headers="headers"
            :items="desserts"
            :loading="loading" 
            dense
            disable-pagination 
            hide-default-footer
            :items-per-page="50"
            class="elevation-2">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template>
            <template v-slot:[`item.proyecto_fecha_aprobacion`]="{item}">
                <span> {{ parseFecha(item.proyecto_fecha_aprobacion) }} </span>
            </template>
            <template v-slot:[`item.fecha_inicio`]="{item}">
                <span> {{ parseFecha(item.fecha_inicio) }} </span>
            </template>
            <template v-slot:[`item.fecha_fin`]="{item}">
                <span> {{ parseFecha(item.fecha_fin) }} </span>
            </template>
            <template v-slot:[`item.estado_programa`]="{item}">
                <v-badge dot :color="item.disponible_para_oferta?'green':'red'" />
                <span> &nbsp;{{ item.estado_programa }} </span> 
            </template>
            <template v-slot:[`item.disponible_para_oferta`]="{item}">
                <p class="text-center ma-0" >
                    <v-badge dot :color="item.disponible_para_oferta?'green':'red'" />
                </p>
            </template>
            <template v-slot:[`item.xseleccionado`]="{item}">
                <div class="text-center">
                    <v-badge v-if="item.xseleccionado=='SI'" dot color="green" />
                    <v-badge v-else dot color="orange" /> 
                </div>
            </template> 
            <template v-slot:[`item.opt`]="{item}">
                <v-menu offset-x offset-y v-if="item.disponible_para_oferta && item.xseleccionado!='SI'">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="my-0 py-0" color="primary" outlined small dark v-bind="attrs" v-on="on">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list class="pa-0">
                        <v-list-item style="background: #1ba060;" dark v-if="item.disponible_para_oferta" link @click="crearSeleccionar(item)">
                            <v-list-item-title>
                                <v-icon>mdi-plus</v-icon>
                                Seleccionar
                            </v-list-item-title>
                        </v-list-item>  
                    </v-list>
                </v-menu> 
            </template>
        </v-data-table> 
 

        <seleccionarModal ref="refSeleccionarModal" v-on:onsuccess="onseleccionado" />
    </div>
</template>
  
<script>
import xaxios from '@/xaxios';
import seleccionarModal from './seleccionar-modal.vue';
import {parseFecha, parseDateFecha} from '../util.ts'
import { seleccionados_dbs } from '@/views/oferta_academica/servicios/seleccionService.ts';
import { periodo_seleccion } from '../servicios/seleccionService.ts';

export default {
    components: {seleccionarModal}, 
    data() {
        return {
            loading: false, 
            headers: [ 
                { text: '#', value: 'ind' },
                { text: 'Programa', value: 'programa_nombre', width:'350' },
                { text: 'Codigos', value: 'codigos', width:'125' },
                { text: 'Aprobado', value: 'proyecto_fecha_aprobacion' },
                { text: 'Resolucion', value: 'resolucion_aprobacion_universidad' },
                { text: 'Aperturas total', value: 'programas_aperturados', align:'center' },
                { text: 'Aperturas sede', value: 'programas_aperturados_sede_origen', align:'center' },
                { text: 'proyecto', value: 'proyecto_id' }, 
                { text: 'seleccionado', value: 'xseleccionado' }, 
                { text: '', value: 'opt' },
            ], 
            desserts: [],
            aprobados: [],
            parseFecha,
            parseDateFecha,  
            filtros:{
                mes:null,
                anio: null,
            },  
            periodo_dis:''
        };
    },
    watch: {
        '$store.state.CARGO': function( ){  
            this.getDatos();
        }, 
    },
    methods: {
        async getDatos(){
            const idsede = this.$store.state.CARGO.idsede;
            const unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const m = this.filtros.mes;
            const a = this.filtros.anio; 
            let ps = `ofertas-academicas/autoria?sede_id=${idsede}&unidad_negocio_id=${unidad}&mes_aprobacion=${m}&gestion_aprobacion=${a}&con_posgrado=1`;
            const url = process.env.VUE_APP_URL_API_PAGOS2+ps;
            this.desserts = [];
            this.loading = true;
            const res = await xaxios.get(url).then(({data})=>data).catch(e=>e);
            // window.console.log('res', res);
            if(res) {
                res.datos.forEach(x=>x.xseleccionado = '')
                // this.desserts = res.datos;
                this.desserts = res.datos.filter(x=>x.disponible_para_oferta);
            }
            this.loading = false;

            this.getAprobados()
            this.getperiododis()
        }, 
        onseleccionado(){
            this.$emit('onsuccessseleccionado'); 
        },
        async getAprobados(){
            this.aprobados = []; 
            
            const q = { 
                sede_portal_id:this.$store.state.CARGO.sede.id, 
                unidad_negocio_id:this.$store.state.CARGO.sede.unidad_negocio,
            } 
            const r = await seleccionados_dbs(q)
            if(r && r.seleccionados_dbs){
                this.aprobados = r.seleccionados_dbs
                this.aprobados.forEach(x=>{
                    const ex = this.desserts.find(e=>e.proyecto_id==x.proyecto_id)
                    if(ex) ex.xseleccionado= 'SI'
                })
            } 
        },
        async getperiododis(){
            this.periodo_dis = '';
            const u = this.$store.state.CARGO.sede.unidad_negocio;
            const r = await periodo_seleccion(u)
            if(r && r.periodo_seleccion){
                const d = r.periodo_seleccion;
                this.periodo_dis = `<small>del</small> <span class='green--text'>${parseDateFecha(d.fecha_inicio, true)}</span> <small>al</small> <span class='red--text'>${parseDateFecha(d.fecha_final,true)}</span>`
            }else{
                this.periodo_dis = `<span class='red--text'>no disponible</span.`
            }
        },
        async getGestiones() { 

            const d = new Date();
            const m = d.getMonth()+1;
            const anio = d.getFullYear(); 

            this.filtros.mes = m; 
            this.filtros.anio = anio;  
            
            this.getDatos(); 
        },

        //
        async crearSeleccionar(proy){ 
            const rol = this.$store.state.CARGO.id;
            const p = rol == 1 || rol == 11 ||rol == 12 
            if(!p){
                this.$root.$notify.show(`rol de usuario no permitido`, {color:'red',x: 'right',});
                return;
            } 
            this.$refs.refSeleccionarModal.openmodal(proy,'AUTORIA');
        },  
        // 
        getRows() {
            return this.desserts
        }
    },
    mounted() { 
        this.desserts = []; 
        this.getGestiones();  
    },
};
</script>
  